import { RecipeDetail } from "@corpuscomplete/core-ui/nutrition/recipe/detail";
import { RecipeDetailPage } from "@corpuscomplete/web/modules/nutrition/recipe/pages/recipe-detail";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";

export const Route = createFileRoute("/_authenticated/recipes/$id")({
  validateSearch: z.object({ variationId: z.string().optional() }),
  component: () => {
    const { id } = Route.useParams();
    const { variationId } = Route.useSearch();
    return <RecipeDetailPage id={id} variationId={variationId} />;
  },
  loader: async ({ params, context }) => {
    if (context.zero) {
      RecipeDetail.preload(context.zero, params.id);
    }
  },
});
